module.exports = __webpack_public_path__ + "img/feature-3.73672da6.png";